import { BanknotesIcon, PowerIcon } from '@heroicons/react/24/outline';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';

import '../paySurge.css';

export type SurgeToastMessage = {
  kind: 'on' | 'off' | 'paused';
  title: string;
  message: string;
};

type Props = {
  toast: SurgeToastMessage | null;
  onDismiss: () => void;
};

const TOAST_TTL_MS = 6_000;

/**
 * The surge pay confirmations (GRAVY-10443): "Surge pay turned on" on the
 * client page, "Pay surge paused" on the job. The app has no toast service of
 * its own, so this is the one these pages share, drawn as the frames draw it
 * — top right, over the navbar.
 */
const SurgeToast = ({ toast, onDismiss }: Props) => {
  useEffect(() => {
    if (!toast) return undefined;
    const timer = window.setTimeout(onDismiss, TOAST_TTL_MS);
    return () => window.clearTimeout(timer);
  }, [toast, onDismiss]);

  if (!toast) return null;
  const Icon = toast.kind === 'paused' ? BanknotesIcon : PowerIcon;

  return createPortal(
    <div className="paysurge-toast" role="status" data-testid="surgeToast">
      <Icon
        className={`paysurge-toasticon is-${toast.kind}`}
        aria-hidden="true"
      />
      <span className="paysurge-toasttext">
        <span className="paysurge-toasttitle">{toast.title}</span>{' '}
        <span className="paysurge-toastmessage">{toast.message}</span>
      </span>
    </div>,
    document.body,
  );
};

export default SurgeToast;
